// @ts-nocheck
/* eslint-disable */
export const appStart24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6328 11.134C22.2995 11.5189 22.2995 12.4811 21.6328 12.866L7.93359 20.7753C7.26693 21.1602 6.43359 20.679 6.43359 19.9092L6.43359 4.09075C6.43359 3.32095 7.26693 2.83983 7.93359 3.22473L21.6328 11.134Z" fill="currentColor"/></svg>`,
    name: 'start-24' as const
};